import { VisitSalesItemRequirementsValidationResultModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class VisitValidationService {
  private static baseUrl: string = '/api/visit';

  public static tags = {
    validateVisitSalesItemRequirements: 'validateVisitSalesItemRequirements',
  };

  static validateVisitSalesItemRequirements = (
    visitId: number,
  ): Promise<VisitSalesItemRequirementsValidationResultModel[]> => {
    return trackPromise(
      new Promise<VisitSalesItemRequirementsValidationResultModel[]>(
        (resolve, reject) => {
          http(`${this.baseUrl}/validaterequirements/${visitId}`)
            .get<VisitSalesItemRequirementsValidationResultModel[]>()
            .then((json) =>
              json.map(
                (result) =>
                  new VisitSalesItemRequirementsValidationResultModel(result),
              ),
            )
            .then(resolve)
            .catch((error) => {
              reject(error);
            });
        },
      ),
    );
  };
}
